import { useContext } from "react";
import { ThemeContext } from "styled-components";

import { theme } from "./consts";

/** Use TOMIS theme across entire application.
 *
 * You MUST use the `ThemeProvider` somewhere above this component,
 * ideally at the root of your application.
 *
 * ## Example Usage
 * ```tsx
 * import { useTheme } from "@tomis-tech/chat-ui";
 *
 * const MyComponent: React.FC = () => {
 *   const theme = useTheme();
 *   return <div style={{ backgroundColor: theme.colors.primary }} />;
 * };
 * ```
 */
export const useTheme = () => useContext(ThemeContext) || theme;
